"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languagePreferenceDefaultValue = exports.LanguagePreferences = exports.languagePreferenceSchema = void 0;
const zod_1 = require("zod");
exports.languagePreferenceSchema = zod_1.z.enum(['en', 'es', 'pt-BR']);
exports.LanguagePreferences = {
    en: 'English',
    es: 'Spanish',
    'pt-BR': 'Portuguese (Brazil)',
};
exports.languagePreferenceDefaultValue = 'pt-BR';
